import React from "react";

import "../styles.scss";
import "../scripts";

import {
  KameleonElement,
  primaryCollectionBlock,
  getDefaultProps,
  renderTertiaryBlock,
} from "@kameleon-core/lib";
import { Box } from "theme-ui";
import { Variants } from "@kameleon-util/global-theme";
import {
  blockConfig,
  ContentCollectionItem,
  ContentCollectionItemType,
} from "./components/content-collection-item";

import blockinfo from "./blockinfo.json";
import defaults from "./defaults.json";
import {
  ContentCollectionType as ComponentType,
  layoutOptions,
} from "./types/prop-types";

type ContentCollectionType = {
  PrimaryBlocks: ContentCollectionItemType[];
} & ComponentType;

export const ContentCollection = primaryCollectionBlock<ContentCollectionType>(
  blockConfig,
  ({
    PrimaryBlocks,
    TertiaryBlock,
    image,
    layoutProps,
  }: ContentCollectionType) => (
    <Box className="primary-collection-content-collection-two-col-grid-medium-image-v1 section_layout31">
      <Box className="padding-global">
        <Box className="container-large padding-section-large">
          <Box className="layout31_component">
            <Box
              sx={{ order: layoutProps.mediaPlacement === "left" ? 0 : 1 }}
              className="layout31_image-wrapper"
            >
              <Variants.Image
                src={image.url}
                loading="lazy"
                alt={image.alt}
                className="layout31_image"
              />
            </Box>
            <Box className="layout31_content">
              <Box className="w-embed" />
              <Box className="layout31_item-list">
                {PrimaryBlocks?.map((primaryBlockProps, index) => (
                  <Box key={index} className="layout31_item">
                    <ContentCollectionItem {...primaryBlockProps} />
                  </Box>
                ))}
              </Box>
              {TertiaryBlock && renderTertiaryBlock(TertiaryBlock)}
            </Box>
          </Box>
        </Box>
      </Box>
    </Box>
  )
);

ContentCollection.defaultProps =
  getDefaultProps<ContentCollectionType>(defaults);

export const Element: KameleonElement = {
  component: ContentCollection,
  blockInfo: blockinfo,
  defaultProps: {
    layoutProps: defaults.layoutProps,
    contentProps: defaults.contentProps,
  },
  layoutOptions,
};
